import ChildMinusTime from '../dto/ChildMinusTime';
import ChildPlusTime from '../dto/ChildPlusTime';
import ChildProofOfTimes from '../dto/ChildProofOfTimes';
import MinusTime from '../dto/MinusTime';
import PlusTime from '../dto/PlusTime';
import axios from 'axios';

export default class ChildTimeManagementRepository {
    static findPlusTimes(childId, year, month) {
        return new Promise(resolve => {
            axios
                .get('/children/' + childId + '/child-plus-times?year=' + year + '&month=' + month)
                .then(response => resolve(response.data.data.map(data => ChildPlusTime.fromData(data))));
        });
    }

    static findPlusTime(id) {
        return new Promise(resolve => {
            axios
                .get('/child-plus-times/' + id)
                .then(response => resolve(ChildPlusTime.fromData(response.data.data)));
        });
    }

    static findPlusTimeSuggestions(childId, year, month) {
        return new Promise(resolve => {
            axios
                .get('/children/' + childId + '/child-time-plus-suggestions/' + year + '-' + month)
                .then(response => resolve(response.data.data.map(data => PlusTime.fromData(data))));
        });
    }

    static findMinusTimes(childId, year, month) {
        return new Promise(resolve => {
            axios
                .get('/children/' + childId + '/child-minus-times?year=' + year + '&month=' + month)
                .then(response => resolve(response.data.data.map(data => ChildMinusTime.fromData(data))));
        });
    }

    static findMinusTime(id) {
        return new Promise(resolve => {
            axios
                .get('/child-minus-times/' + id)
                .then(response => resolve(ChildMinusTime.fromData(response.data.data)));
        });
    }

    static findMinusTimeSuggestions(childId, year, month) {
        return new Promise(resolve => {
            axios
                .get('/children/' + childId + '/child-time-minus-suggestions/' + year + '-' + month)
                .then(response => resolve(response.data.data.map(data => MinusTime.fromData(data))));
        });
    }

    static findProofOfTimes(childId, year, month) {
        return new Promise(resolve => {
            axios
                .get('/children/' + childId + '/proof-of-times?year=' + year + '&month=' + month)
                .then(response => resolve(response.data.data.map(data => ChildProofOfTimes.fromData(data))));
        });
    }

    static createPlusTime(childId, plusTime) {
        return new Promise(resolve => {
            axios
                .post('/child-plus-times', {
                    child_id: childId,
                    range: plusTime.timeRange,
                    day: plusTime.day,
                })
                .then(() => resolve());
        });
    }

    static createPlusTimes(childId, plusTimes) {
        return new Promise(resolve => {
            axios
                .post('/child-plus-times-bulk', {
                    child_id: childId,
                    times: plusTimes.map((plusTime) => {
                        return {
                            range: plusTime.timeRange,
                            day: plusTime.day,
                        }
                    })
                })
                .then(() => resolve());
        });
    }

    static createProof(childId, year, month) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/children/${childId}/proof-of-times`, {year, month})
                .then(() => resolve())
                .catch(error => reject(error));
        });
    }

    static updatePlusTime(plusTime) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/child-plus-times/${plusTime.id}`, {
                    care_cost_hourly_id: plusTime.careCostHourly ? plusTime.careCostHourly.id : null,
                    range: plusTime.timeRange.start.toString() + '-' + plusTime.timeRange.end.toString(),
                })
                .then(() => resolve())
                .catch(error => reject(error));
        });
    }

    static updateMinusTime(minusTime) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/child-minus-times/${minusTime.id}`, {
                    range: minusTime.timeRange.start.toString() + '-' + minusTime.timeRange.end.toString(),
                })
                .then(() => resolve())
                .catch(error => reject(error));
        });
    }

    static createMinusTime(childId, minusTime) {
        return new Promise(resolve => {
            axios
                .post('/child-minus-times', {
                    child_id: childId,
                    range: minusTime.timeRange,
                    day: minusTime.day,
                })
                .then(() => resolve());
        });
    }

    static createMinusTimes(childId, minusTimes) {
        return new Promise(resolve => {
            axios
                .post('/child-minus-times-bulk', {
                    child_id: childId,
                    times: minusTimes.map((minusTime) => {
                        return {
                            range: minusTime.timeRange,
                            day: minusTime.day,
                        }
                    })
                })
                .then(() => resolve());
        });
    }

    static deletePlusTime(plusTime) {
        return new Promise(resolve => {
            axios
                .delete('/child-plus-times/' + plusTime.id)
                .then(() => resolve());
        });
    }

    static deleteMinusTime(minusTime) {
        return new Promise(resolve => {
            axios
                .delete('/child-minus-times/' + minusTime.id)
                .then(() => resolve());
        });
    }

    static deleteProofOfTime(proofOfTime) {
        return new Promise(resolve => {
            axios
                .delete('/child-proof-of-times/' + proofOfTime.id)
                .then(() => resolve());
        });
    }

    static deleteProofOfTimeBulk(childId, selectectProofOfTime) {
        return new Promise(resolve => {
            axios
                .delete('/child-proof-of-times-bulk', {
                    params: {
                        child_id: childId,
                        times: selectectProofOfTime.map((proofOfTime) => {
                            return {
                                id: proofOfTime.id,
                            }
                        })
                    }
                })
                .then(() => resolve());
        });
    }
}
